/** Next.js CoolClimate calculator local dev (see coolclimate-calculator README). */
export const LOCAL_CALCULATOR_DEV_URL = 'http://localhost:3001/calculator';

/** Same calculator app embedded on ClimatePlans (Challenge default when env unset). */
export const DEFAULT_CALCULATOR_EMBED_URL = 'https://climateplans.org/calculator';

export const CALCULATOR_HEIGHT_MESSAGE = 'calculator-height';

const IFRAME_HEIGHT_BUFFER_PX = 48;
const IFRAME_MIN_HEIGHT_PX = 640;
/** Summary + “show all” opportunities can exceed 10kpx; keep a high safety ceiling only. */
const IFRAME_ABSOLUTE_MAX_HEIGHT_PX = 20000;

export const clampCalculatorEmbedHeight = (contentHeight: number): number => {
  const h = Math.max(IFRAME_MIN_HEIGHT_PX, contentHeight + IFRAME_HEIGHT_BUFFER_PX);
  return Math.min(IFRAME_ABSOLUTE_MAX_HEIGHT_PX, h);
};

const isLocalHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
};

/** Challenge always embeds the Next.js calculator (legacy Firebase widget removed). */
export const isNextCalculatorEmbedActive = (): boolean =>
  Boolean(resolveCalculatorEmbedBaseUrl());

/**
 * Base URL for the Next calculator iframe (includes `/calculator` path).
 * Override with REACT_APP_CALCULATOR_URL; localhost defaults to port 3001.
 */
export const resolveCalculatorEmbedBaseUrl = (): string => {
  let fromEnv = (process.env.REACT_APP_CALCULATOR_URL || '').trim();
  if (!fromEnv && isLocalHost() && process.env.REACT_APP_CALCULATOR_URL_LOCAL) {
    fromEnv = process.env.REACT_APP_CALCULATOR_URL_LOCAL.trim();
  }

  if (fromEnv) {
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
      const abs = fromEnv.startsWith('/') ? new URL(fromEnv, origin).href : new URL(fromEnv).href;
      const parsed = new URL(abs);
      const localCalc =
        parsed.hostname === 'localhost' ||
        parsed.hostname === '127.0.0.1' ||
        parsed.hostname === '::1';
      if (localCalc && !isLocalHost()) {
        return DEFAULT_CALCULATOR_EMBED_URL.replace(/\/$/, '');
      }
      return parsed.href.replace(/\/$/, '');
    } catch (_err) {
      // fall through to defaults
    }
  }

  if (typeof window !== 'undefined' && isLocalHost()) {
    return LOCAL_CALCULATOR_DEV_URL;
  }

  return DEFAULT_CALCULATOR_EMBED_URL.replace(/\/$/, '');
};

export const calculatorEmbedOrigin = (baseUrl: string): string => {
  try {
    return new URL(baseUrl).origin;
  } catch (_err) {
    return '';
  }
};

/** Challenge embed: Take Action off (`takeAction=0`); optional location prefill for iframe. */
export const buildChallengeCalculatorIframeSrc = (
  baseUrl: string,
  embedLocation?: { location: string; geofips: string }
): string => {
  const url = new URL(baseUrl);
  url.searchParams.set('takeAction', '0');
  if (embedLocation) {
    url.searchParams.set('location', embedLocation.location);
    url.searchParams.set('geofips', embedLocation.geofips);
  }
  return url.toString();
};
